<template>
  <v-app fluid fill-height>
    <Header v-if="this.$auth.isAuthenticated()" :titulo="header.titulo"></Header>
    <Sidebar
      v-if="this.$auth.isAuthenticated()"
      :titulo="sidebar.titulo"
      :descripcion="sidebar.descripcion"
      :menu="$store.usuario.menu"
    ></Sidebar>
    <v-main class="page-container">
      <router-view></router-view>
    </v-main>
    <Toast></Toast>
  </v-app>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import Toast from "@/plugins/ToastService/Toast.vue";

export default {
  name: "App",
  components: {
    Header,
    Sidebar,
    Toast,
  },
  data: () => ({
    header: {
      titulo: "Sistema",
    },
    sidebar: {
      titulo: "Sistema",
      descripcion: "",
      menu: [],
    },
  }),
  methods: {},
};
</script>
<style scoped>
</style>
